import React from 'react';
import Header from '../../layout/Header';
import Footer from '../../layout/Footer';
import {
  LegalMobileDropdown,
  LegalDesktopSidebar,
  useActiveSection,
  scrollToSection
} from '../../components/legal/LegalNav';

const BusinessTerms = () => {
  const sections = [
    { id: "intro", title: "1. Introduction" },
    { id: "company", title: "2. Company Information" },
    { id: "responsibilities", title: "3. User Responsibilities" },
    { id: "account", title: "4. Account Registration" },
    { id: "service", title: "5. Service Provision" },
    { id: "intellectual", title: "6. Intellectual Property" },
    { id: "media", title: "7. Media & Photos" },
    { id: "liability", title: "8. Liability" },
    { id: "amendments", title: "9. Amendments" },
    { id: "reliability", title: "10. System Reliability" },
    { id: "cancellations", title: "11. Provider Cancellations" },
    { id: "payments", title: "12. Payment Processing" },
    { id: "marketing", title: "13. Marketing & Promotions" },
  ];

  const [activeSection, setActiveSection] = useActiveSection(sections);

  const handleSelectSection = (targetId) => {
    setActiveSection(targetId);
    scrollToSection(targetId, window.innerWidth < 768);
  };

  return (
    <div className="landing-page-body" style={{ backgroundColor: "#F9FAFB" }}>
      <div className="header-bg">
        <Header />
        {/* Hero Section */}
        <div style={{ padding: "60px 0 80px 0", color: "#white", textAlign: "center" }}>
          <div className="container text-white">
            <span className="br-16 poppins f-12 fw-semibold mb-3" style={{ backgroundColor: "rgba(255, 255, 255, 0.15)", color: "#ffffff", border: "1px solid rgba(255, 255, 255, 0.25)", textTransform: "uppercase", letterSpacing: "1px", padding: "8px 20px", display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: "1", verticalAlign: "middle" }}>Next Salon Agreement</span>
            <h1 className="poly fw-bold text-white mb-3" style={{ fontSize: "2.8rem" }}>Terms & Conditions</h1>
            <p className="poppins text-white-50" style={{ maxWidth: "600px", margin: "0 auto", fontSize: "16px" }}>
              Please read these terms and conditions carefully before using our platform. Last updated July 2026.
            </p>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row">
          {/* Sidebar Navigation (Desktop / Tablet) */}
          <div className="col-md-4 col-lg-3 d-none d-md-block">
            <LegalDesktopSidebar
              sections={sections}
              activeSection={activeSection}
              onSelectSection={handleSelectSection}
            />
          </div>

          {/* Terms Content */}
          <div className="col-md-8 col-lg-9 col-12">
            {/* Collapsible Section Dropdown (Mobile) */}
            <LegalMobileDropdown
              sections={sections}
              activeSection={activeSection}
              onSelectSection={handleSelectSection}
            />

            <div className="bg-white p-4 p-md-5 br-16 shadow-sm border poppins color-primary" style={{ lineHeight: "1.8", color: "#374151" }}>
              
              <div id="intro" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">1. Introduction</h3>
                <p>Welcome to Next Salon. By using our platform, you agree to comply with and be bound by the following terms and conditions.</p>
              </div>

              <hr className="my-4" />

              <div id="company" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">2. Company Information</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li className="mb-2"><span className="fw-semibold">Full Legal Name: </span> Next Salon Ltd.</li>
                  <li><span className="fw-semibold">Company Registration: </span> Registered in [Your Country], with registration number [Your Company Registration Number].</li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="responsibilities" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">3. User Responsibilities</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li className="mb-2">Users must provide accurate information, respect the platform’s guidelines, and use the platform for lawful purposes.</li>
                  <li className="mb-2">Users must not engage in fraudulent activities or misuse the platform.</li>
                  <li>Users must be 16 years or older to use the platform.</li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="account" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">4. Account Registration</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li className="mb-2">
                    <span className="fw-semibold">Required Information: </span>
                    Users need to provide their full name, email address, phone number, and a secure password. Service providers may need to provide additional information such as business name, address, and proof of certifications.
                  </li>
                  <li>
                    <span className="fw-semibold">Verification: </span>
                    Users receive an email to verify their account. Service providers may undergo an additional vetting process, including validation of their credentials and business legitimacy.
                  </li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="service" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">5. Service Provision</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li className="mb-2"><span className="fw-semibold">Terms for Providers: </span> Providers agree to keep their availability, pricing, and service details up-to-date. They are responsible for the quality of their services and complying with relevant regulations.</li>
                  <li className="mb-2"><span className="fw-semibold">Booking and Payment: </span> Users can book services through the platform and make payments online. Providers receive payments through the platform minus a service fee.</li>
                  <li><span className="fw-semibold">Cancellations and Refunds: </span> Cancellations and refunds are dependent on the individual service provider’s notice period policy. Providers must clearly communicate their cancellation policies to clients at the time of booking. For late cancellations or no-shows, automatic charges may apply according to the provider’s policy.</li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="intellectual" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">6. Intellectual Property</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li className="mb-2"><span className="fw-semibold">Content Ownership: </span> Content created by Next Salon (e.g., logos, platform design) is owned by Next Salon. User-generated content remains the property of the users but grants Next Salon a non-exclusive license to use it for promotional purposes.</li>
                  <li><span className="fw-semibold">Proper Use: </span> Users can share content on social media but must credit Next Salon and not alter the content in misleading ways.</li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="media" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">7. Media and Photos</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li><span className="fw-semibold">Rights to Photos: </span> Service providers often take photos of their clients and post them on social media platforms like Instagram. By using Next Salon, service providers agree to also post these photos on Next Salon. Clients must provide consent for their photos to be used by service providers and Next Salon for promotional purposes. Next Salon will include a feature within the platform for clients to provide explicit consent during the booking or appointment process.</li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="liability" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">8. Liability</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li className="mb-2">
                    <span className="fw-semibold">Limitations: </span>
                    Next Salon is not liable for any direct or indirect damages resulting from the use of the platform, including disputes between users and providers. Next Salon’s liability is limited to the amount paid by the user for the services in dispute.
                  </li>
                  <li>
                    <span className="fw-semibold">Dispute Handling: </span>
                    Next Salon provides a dispute resolution process but is not responsible for the actual service provided by the beauty professionals. Next Salon will facilitate mediation and provide clear guidelines for handling disputes.
                  </li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="amendments" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">9. Amendments</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li>
                    <span className="fw-semibold">Notification of Changes: </span>
                    Next Salon will notify users of any changes to the Terms and Conditions via email and a notice on the platform. Continued use of the platform after changes implies acceptance.
                  </li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="reliability" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">10. System Reliability</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li>
                    <span className="fw-semibold">Technical Infrastructure: </span>
                    Next Salon will maintain a robust technical infrastructure with regular updates and backups. A contingency plan will be in place to handle system outages, and 24/7 customer support will be available to address technical issues promptly.
                  </li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="cancellations" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">11. Service Provider Cancellations</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li>
                    <span className="fw-semibold">Cancellation Policy: </span>
                    Service providers must clearly communicate their cancellation policies at the time of booking. Next Salon will implement a policy that includes penalties for frequent cancellations by providers. A rating and feedback system will be in place to monitor provider reliability.
                  </li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="payments" className="mb-5 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">12. Payment Processing</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li>
                    <span className="fw-semibold">Timely Payments: </span>
                    Next Salon will ensure timely and accurate payment processing. Payment schedules and procedures will be clearly outlined, and a dedicated support channel will be available for addressing any payment issues. Next Salon will establish relationships with multiple payment processors to avoid single points of failure.
                  </li>
                </ul>
              </div>

              <hr className="my-4" />

              <div id="marketing" className="mb-0 pt-3">
                <h3 className="poly fw-bold color-primary mb-3">13. Marketing and Promotions</h3>
                <ul className="ps-3" style={{ listStyleType: "disc" }}>
                  <li>
                    <span className="fw-semibold">Promotional Tools: </span>
                    Next Salon will provide tools for service providers to create and manage promotions. Guidelines and tracking tools will be available to ensure promotions are fair and transparent.
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default BusinessTerms